import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';

const DeleteComponent = observer(({ visible, onClose }) => {
	const { TOURPACKAGECATEGORY } = useStore();
	const [loading, setLoading] = useState(false);

	const handleDelete = async () => {
		setLoading(true);
		try {
			await TOURPACKAGECATEGORY.deleteCategory({
				id: visible.id,
				versionNo: visible.versionNo,
			});
			Notification.success({
				message: 'Tour Package Category Deleted successfully!',
			});
			onClose();
		} catch (error) {
			Notification.error({
				message: 'Error deleting tour package category',
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Delete Tour Package Category"
			open={visible}
			onCancel={onClose}
			footer={[
				<Button key="back" onClick={onClose}>
					Cancel
				</Button>,
				<Button
					key="submit"
					type="primary"
					danger
					loading={loading}
					onClick={handleDelete}
				>
					Delete
				</Button>,
			]}
		>
			<p>Are you sure you want to delete this tour package category?</p>
		</Modal>
	);
});

export default DeleteComponent;
